// @ts-nocheck
import React from "react";
import { Link } from "react-router-dom";
import { withdrawalDeclarationPath } from "../Order/depositDeclarationModel";
import { DepositHistoryStatus } from "../Order/DepositSenderConfirm";
import "../Order/depositDeclaration.css";
import { makeCoinImageOnError, withdrawHistoryTxExplorerEligible } from "./withdrawPageHelpers";
import {
  resolveTxExplorerUrl,
  resolveAddressExplorerUrl,
  WithdrawHistCopyIcon,
  WithdrawHistExternalIcon,
  withdrawHistoryClickShouldIgnoreModal,
  withdrawStatusTone,
} from "./withdrawPageShared";
import { useWithdrawPage } from "./WithdrawPageContext";

export default function WithdrawPageRecentSection() {
  /* eslint-disable no-unused-vars -- context exposes many fields; only subset used in this section */
  const {
    navigate,
    isMobile,
    setIsMobile,
    stepperWrapRef,
    railDims,
    setRailDims,
    withdrawSubmitting,
    setWithdrawSubmitting,
    emailVerifyCode,
    setEmailVerifyCode,
    withdrawOtpSending,
    setWithdrawOtpSending,
    withdrawOtpResendSec,
    setWithdrawOtpResendSec,
    withdrawWithdrawalFlowBusy,
    setWithdrawWithdrawalFlowBusy,
    withdrawConfirmBusy,
    setWithdrawConfirmBusy,
    withdrawSummaryContinueBusy,
    setWithdrawSummaryContinueBusy,
    withdrawalRequestLockRef,
    withdrawHistoryPromiseRef,
    selectedCoin,
    setSelectedCoin,
    withdrawCoins,
    setWithdrawCoins,
    loadingWithdrawCoins,
    setLoadingWithdrawCoins,
    coinSearchQuery,
    setCoinSearchQuery,
    recentWithdrawRows,
    setRecentWithdrawRows,
    loadingWithdrawHistory,
    setLoadingWithdrawHistory,
    fundMain,
    setFundMain,
    selectedWithdrawHistoryRow,
    setSelectedWithdrawHistoryRow,
    selectedNetwork,
    setSelectedNetwork,
    isWithdrawDetailsOpen,
    withdrawToTab,
    setWithdrawToTab,
    agceRecipientTab,
    setAgceRecipientTab,
    agceRecipientEmail,
    setAgceRecipientEmail,
    agceRecipientPhone,
    setAgceRecipientPhone,
    agceRecipientId,
    setAgceRecipientId,
    agceRecipientUsername,
    agceTouched,
    setAgceTouched,
    showAddressBookPanel,
    setShowAddressBookPanel,
    addressBookSubTab,
    setAddressBookSubTab,
    withdrawAddress,
    setWithdrawAddress,
    withdrawAddressTouched,
    setWithdrawAddressTouched,
    withdrawAddressValidError,
    setWithdrawAddressValidError,
    withdrawAddressValidatedKey,
    setWithdrawAddressValidatedKey,
    isWithdrawAddressValidating,
    setIsWithdrawAddressValidating,
    withdrawAddressValidationReqIdRef,
    withdrawAddrValidateDebounceTimerRef,
    withdrawConfirmProceedTimerRef,
    satoshiWhitelistConfirmInFlightRef,
    isAvailSourceOpen,
    setIsAvailSourceOpen,
    isAvailSourcePinned,
    setIsAvailSourcePinned,
    isAvailSourceContextLock,
    setIsAvailSourceContextLock,
    isNetworkFeeInfoOpen,
    setIsNetworkFeeInfoOpen,
    withdrawAmountInput,
    setWithdrawAmountInput,
    withdrawAmountTouched,
    setWithdrawAmountTouched,
    isLimitInfoOpen,
    setIsLimitInfoOpen,
    isWithdrawMetaRefreshing,
    setIsWithdrawMetaRefreshing,
    availSourceRef,
    phoneCountry,
    setPhoneCountry,
    isCountryOpen,
    setIsCountryOpen,
    countryRef,
    isWithdrawConfirmOpen,
    setIsWithdrawConfirmOpen,
    withdrawConfirmRef,
    isWithdrawSummaryOpen,
    setIsWithdrawSummaryOpen,
    withdrawSummaryRef,
    isPasskeyOpen,
    setIsPasskeyOpen,
    passkeyRef,
    isAuthAppOpen,
    setIsAuthAppOpen,
    authAppRef,
    authAppCode,
    setAuthAppCode,
    isChooseAuthOpen,
    setIsChooseAuthOpen,
    chooseAuthRef,
    isEmailVerifyOpen,
    setIsEmailVerifyOpen,
    emailVerifyRef,
    isMobileVerifyOpen,
    setIsMobileVerifyOpen,
    mobileVerifyRef,
    isSecUnavailableOpen,
    setIsSecUnavailableOpen,
    secUnavailable,
    setSecUnavailable,
    isSecResetConfirmOpen,
    setIsSecResetConfirmOpen,
    secResetAck,
    setSecResetAck,
    isSecReqOpen,
    setIsSecReqOpen,
    secReqDone,
    setSecReqDone,
    isRequestSubmittedOpen,
    setIsRequestSubmittedOpen,
    isSecurityResetSuccessOpen,
    setIsSecurityResetSuccessOpen,
    verificationContext,
    setVerificationContext,
    withdrawSecuritySettings,
    setWithdrawSecuritySettings,
    withdrawVerifyMethod,
    setWithdrawVerifyMethod,
    withdrawFundPassword,
    setWithdrawFundPassword,
    withdrawFundPasswordError,
    setWithdrawFundPasswordError,
    withdrawFundPasswordVisible,
    setWithdrawFundPasswordVisible,
    isNoMethodsModalOpen,
    setIsNoMethodsModalOpen,
    isWithdrawVerifyCombinedOpen,
    setIsWithdrawVerifyCombinedOpen,
    withdrawVerifyFieldErrors,
    setWithdrawVerifyFieldErrors,
    mobileVerifyCode,
    setMobileVerifyCode,
    withdrawOtpFallbackAfterPasskey,
    setWithdrawOtpFallbackAfterPasskey,
    closeAllOverlays,
    isAwaitingApprovalOpen,
    setIsAwaitingApprovalOpen,
    awaitingApprovalRef,
    isRecipientAmountOpen,
    setIsRecipientAmountOpen,
    recipientAmountRef,
    isSetPayPinOpen,
    setIsSetPayPinOpen,
    payPinDigits,
    setPayPinDigits,
    payPinShow,
    setPayPinShow,
    payPinRefs,
    isSaveAddressOpen,
    setIsSaveAddressOpen,
    saveAddrLabel,
    setSaveAddrLabel,
    saveAddrCoin,
    setSaveAddrCoin,
    saveAddrUniversal,
    setSaveAddrUniversal,
    saveAddrValue,
    setSaveAddrValue,
    saveAddrNetwork,
    setSaveAddrNetwork,
    saveAddrMemo,
    setSaveAddrMemo,
    saveAddrWhitelistMethod,
    setSaveAddrWhitelistMethod,
    addressWhitelistFlow,
    setAddressWhitelistFlow,
    satoshiDepositAddress,
    setSatoshiDepositAddress,
    satoshiDepositMemo,
    setSatoshiDepositMemo,
    satoshiDepositLoading,
    setSatoshiDepositLoading,
    satoshiDepositError,
    setSatoshiDepositError,
    saveAddrSatoshiPolling,
    setSaveAddrSatoshiPolling,
    satoshiWhitelistAwaitingProof,
    setSatoshiWhitelistAwaitingProof,
    whitelistMetamaskBusy,
    setWhitelistMetamaskBusy,
    metamaskInstallModalOpen,
    setMetamaskInstallModalOpen,
    eip1193BrowserProviderDetected,
    setEip1193BrowserProviderDetected,
    saveAddrSubmitAttempted,
    setSaveAddrSubmitAttempted,
    saveAddrSaving,
    setSaveAddrSaving,
    addressBookEntries,
    setAddressBookEntries,
    addressBookLoading,
    setAddressBookLoading,
    withdrawalAddressHistory,
    setWithdrawalAddressHistory,
    withdrawalAddressHistoryLoading,
    setWithdrawalAddressHistoryLoading,
    addressBookDeleteConfirm,
    setAddressBookDeleteConfirm,
    addressBookDeleteBusy,
    setAddressBookDeleteBusy,
    saveCoinMenuOpen,
    setSaveCoinMenuOpen,
    saveNetworkMenuOpen,
    setSaveNetworkMenuOpen,
    saveCoinSelectRef,
    saveNetworkSelectRef,
    isWithdrawHistoryDetailOpen,
    setIsWithdrawHistoryDetailOpen,
    hideWithdrawErrorNotices,
    setHideWithdrawErrorNotices,
    recentWithdrawTab,
    setRecentWithdrawTab,
    recentWithdrawRowsVisible,
    withdraw24hUsage,
    setWithdraw24hUsage,
    reloadWithdrawCatalog,
    reloadWithdrawal24hUsage,
    refetchWithdrawHistory,
    refetchAddressBook,
    refetchWithdrawalAddressHistory,
    payPinValue,
    isPayPinComplete,
    resetPayPin,
    handlePayPinDigit,
    handlePayPinKeyDown,
    isStep2Done,
    selectedCoinObj,
    isStep1Done,
    activeWithdrawNetworks,
    minWithdrawForSelection,
    effectiveAvailable,
    filteredWithdrawCoins,
    trendingWithdrawCoins,
    coinModalDisplay,
    coinQuickPickDisplay,
    saveAddrCoinOptionsList,
    saveAddrNetworkOptionsEffective,
    saveAddrChainCanonical,
    selectedCoinMeta,
    isWithdrawFormValid,
    withdrawAddressInlineError,
    withdrawAmountInlineError,
    summaryNetworkLabel,
    selectedTokenAssetId,
    validateCurrentWithdrawAddress,
    validateCurrentWithdrawAddressRef,
    applyWithdrawalAddressHistoryEntry,
    withdrawStep3Preview,
    getNonPasskeyEnabledMethods,
    hasConfigurableNonPasskeyMethods,
    withdrawCombinedVerificationReady,
    sendSingleWithdrawalOtp,
    withdrawOtpResendActive,
    submitWithdrawalWithEnabledMethods,
    handlePasskeyWithdrawFlow,
    handleWithdrawalSubmitFromCode,
    handleWithdrawalSubmitFundPassword,
    openWithdrawVerificationModal,
    openWithdrawOtpFallbackFromPasskey,
    openWithdrawVerificationCombinedOnly,
    shouldShowPasskeyLink,
    shouldShowSwitchMethodLink,
    openSecurityUnavailableFlow,
    openPasskeysOnlyRequirements,
    secUnavailableSelectedCount,
    secRequirementsMode,
    secReqTotal,
    secReqCompleted,
    agceErrors,
    handleAgceEmailChange,
    handleAgcePhoneChange,
    handleWithdrawMaxClick,
    handleWithdrawAmountChange,
    copyWithdrawText,
    pasteWithdrawAuthAppCode,
    onWithdrawAgainFromHistory,
    cancelPendingWithdrawal,
    withdrawCancelBusy,
    saveAddrErrors,
    isSaveAddrValid,
    saveAddrCoinDisplay,
    saveAddrNetworkDisplay,
    clearSatoshiWhitelistPoll,
    resetSaveAddressFormFields,
    handleWhitelistFlowBack,
    copySatoshiDepositAddress,
    copySatoshiDepositMemo,
    handleSatoshiWhitelistSent,
    handleMetaMaskWhitelistSign,
    resumeMetaMaskWhitelistFromAddressBook,
    resumeSatoshiWhitelistFromAddressBook,
    handleSaveAddressBookSubmit,
    openAddressBookDeleteConfirm,
    confirmAddressBookDelete,
    withdrawProfileReady,
    withdrawKycVerified
  } = useWithdrawPage();
  /* eslint-enable no-unused-vars */
  const openWithdrawRowDetail = (row) => {
    setSelectedWithdrawHistoryRow(row);
    setIsWithdrawHistoryDetailOpen(true);
  };

  return (
    <>
          <div className="recent_deposit_list deposit_history_section">
            <div className="deposit_history_top">
              <h4 className="deposit_history_title">Withdrawal History</h4>
              <div className="withdraw_history_top_actions">
                <label className="withdraw_recent_hide_err">
                  <input
                    type="checkbox"
                    checked={hideWithdrawErrorNotices}
                    onChange={(e) => setHideWithdrawErrorNotices(e.target.checked)}
                  />
                  <span>Hide error notices</span>
                </label>
                <Link to="/user_profile/orders/withdraw_history" className="deposit_history_viewall">
                  More <i className="ri-arrow-right-s-line" aria-hidden="true" />
                </Link>
              </div>
            </div>

            <div className="withdraw_recent_tabs" role="tablist" aria-label="Withdrawal type">
              <button
                type="button"
                role="tab"
                aria-selected={recentWithdrawTab === "address"}
                className={`withdraw_recent_tab${recentWithdrawTab === "address" ? " is-active" : ""}`}
                onClick={() => setRecentWithdrawTab("address")}
              >
                Address
              </button>
              {/* <button
                type="button"
                role="tab"
                aria-selected={recentWithdrawTab === "agce"}
                className={`withdraw_recent_tab${recentWithdrawTab === "agce" ? " is-active" : ""}`}
                onClick={() => setRecentWithdrawTab("agce")}
              >
                AGCX user
              </button> */}
            </div>

            <div className="deposit_history_card">
              {recentWithdrawTab === "address" ? (
                <div className="deposit_history_table_wrap" role="region" aria-label="Withdrawal history table">
                  {loadingWithdrawHistory && recentWithdrawRowsVisible.length === 0 ? (
                    <p className="text-muted small px-2 py-3 mb-0" role="status">
                      Loading withdrawal history…
                    </p>
                  ) : null}
                  {!loadingWithdrawHistory &&
                  recentWithdrawRowsVisible.length === 0 &&
                  recentWithdrawRows.length === 0 ? (
                    <div className="deposit_history_empty" aria-live="polite">
                      <img src="/images/no-data.svg" alt="" className="deposit_history_empty_img" width={120} height={120} />
                    </div>
                  ) : null}
                  {!loadingWithdrawHistory &&
                  recentWithdrawRowsVisible.length === 0 &&
                  recentWithdrawRows.length > 0 ? (
                    <div className="deposit_history_empty" aria-live="polite">
                      <p className="text-muted small mb-0 mt-3 px-2 text-center">
                        No withdrawals to show. Turn off &quot;Hide error notices&quot; to see failed or rejected withdrawals.
                      </p>
                    </div>
                  ) : null}
                  {!loadingWithdrawHistory && recentWithdrawRowsVisible.length > 0 ? (
                    <>
                      <div className="deposit_history_desktop">
                        <div className="deposit_history_head_wrap">
                          <div className="deposit_history_head" role="row">
                            {["Date", "Network", "Amount", "Source wallet", "Address", "TxID", "Status"].map((label) => (
                              <div key={label} className="deposit_history_head_cell" role="columnheader">
                                {label}
                              </div>
                            ))}
                          </div>
                        </div>
                        <div className="deposit_history_body_wrap" aria-label="Recent withdrawals">
                          {recentWithdrawRowsVisible.map((row) => {
                            const networkLabel =
                              row.networkLabel && row.networkLabel !== "—" ? row.networkLabel : row.network;
                            const hasAddr = Boolean(row.addressFull);
                            const hasTx = Boolean(row.txFull);
                            const tone = withdrawStatusTone(row.statusLabel);
                            const addressExplorerHref =
                              hasAddr ? resolveAddressExplorerUrl(row.rawChain || row.network, row.addressFull) : null;
                            const txExplorerHref =
                              hasTx && row.txExplorerEligible
                                ? resolveTxExplorerUrl(row.rawChain || row.network, row.txFull)
                                : null;
                            return (
                              <div
                                key={row.id}
                                className="deposit_history_row"
                                role="row"
                                tabIndex={0}
                                style={{ cursor: "pointer" }}
                                aria-label={`Withdrawal ${row.coin}, ${row.statusLabel}. Open details.`}
                                onClick={(e) => {
                                  if (withdrawHistoryClickShouldIgnoreModal(e.target)) return;
                                  openWithdrawRowDetail(row);
                                }}
                                onKeyDown={(e) => {
                                  if (e.key !== "Enter" && e.key !== " ") return;
                                  e.preventDefault();
                                  openWithdrawRowDetail(row);
                                }}
                              >
                                <div className="deposit_history_row_cell" title={row.date}>
                                  {row.date}
                                </div>
                                <div
                                  className="deposit_history_row_cell"
                                  title={networkLabel !== "—" ? networkLabel : undefined}
                                >
                                  {networkLabel}
                                </div>
                                <div className="deposit_history_row_cell">
                                  {row.amount} {row.coin}
                                </div>
                                <div className="deposit_history_row_cell">{row.source}</div>
                                <div className="deposit_history_row_cell" title={hasAddr ? row.addressFull : undefined}>
                                  <span className="deposit_history_trunc">{row.addressShort}</span>
                                  {hasAddr ? (
                                    <>
                                      <button
                                        type="button"
                                        className="deposit_history_copy_btn"
                                        aria-label="Copy address"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          copyWithdrawText(row.addressFull, "Address copied");
                                        }}
                                      >
                                        <span aria-hidden className="deposit_history_copy_ico">
                                          <WithdrawHistCopyIcon />
                                        </span>
                                      </button>
                                      {addressExplorerHref ? (
                                        <a
                                          className="deposit_history_copy_btn deposit_history_explorer_link"
                                          href={addressExplorerHref}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          aria-label="View address on explorer"
                                          title="View address on explorer"
                                          onClick={(e) => e.stopPropagation()}
                                        >
                                          <span aria-hidden className="deposit_history_copy_ico">
                                            <WithdrawHistExternalIcon />
                                          </span>
                                        </a>
                                      ) : null}
                                    </>
                                  ) : null}
                                </div>
                                <div className="deposit_history_row_cell" title={hasTx ? row.txFull : undefined}>
                                  <span className="deposit_history_trunc">{row.txShort}</span>
                                  {hasTx ? (
                                    <>
                                      <button
                                        type="button"
                                        className="deposit_history_copy_btn"
                                        aria-label="Copy TxID"
                                        title="Copy TxID"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          copyWithdrawText(row.txFull, "TxID copied");
                                        }}
                                      >
                                        <span aria-hidden className="deposit_history_copy_ico">
                                          <WithdrawHistCopyIcon />
                                        </span>
                                      </button>
                                      {txExplorerHref ? (
                                        <a
                                          className="deposit_history_copy_btn deposit_history_explorer_link"
                                          href={txExplorerHref}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          aria-label="View transaction on explorer"
                                          title="View transaction on explorer"
                                          onClick={(e) => e.stopPropagation()}
                                        >
                                          <span aria-hidden className="deposit_history_copy_ico">
                                            <WithdrawHistExternalIcon />
                                          </span>
                                        </a>
                                      ) : null}
                                    </>
                                  ) : null}
                                </div>
                                <div className="deposit_history_row_cell deposit_history_row_cell--action">
                                  <DepositHistoryStatus
                                    row={{
                                      id: row.id,
                                      action: row.needsSenderConfirm ? "Provide Info" : row.statusLabel,
                                      needsSenderConfirm: row.needsSenderConfirm,
                                    }}
                                    badgeClassName={`deposit_history_action_badge is-${row.needsSenderConfirm ? "pending" : tone}`}
                                    showConfirmButton={false}
                                    confirmTo={withdrawalDeclarationPath(row.id)}
                                  />
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>

                      <div className="deposit_history_mobile" aria-label="Recent withdrawals">
                        <div className="withdraw_cards_list">
                          {recentWithdrawRowsVisible.map((row) => {
                            const networkLabelMob =
                              row.networkLabel && row.networkLabel !== "—" ? row.networkLabel : row.network;
                            const hasAddr = Boolean(row.addressFull);
                            const hasTx = Boolean(row.txFull);
                            const tone = withdrawStatusTone(row.statusLabel);
                            const addressExplorerHref =
                              hasAddr ? resolveAddressExplorerUrl(row.rawChain || row.network, row.addressFull) : null;
                            const txExplorerHref =
                              hasTx && row.txExplorerEligible
                                ? resolveTxExplorerUrl(row.rawChain || row.network, row.txFull)
                                : null;
                            return (
                              <div
                                key={row.id}
                                className="withdraw_card_item deposit_hist_mobile_card"
                                tabIndex={0}
                                style={{ cursor: "pointer" }}
                                aria-label={`Withdrawal ${row.coin}, ${row.statusLabel}. Open details.`}
                                onClick={(e) => {
                                  if (withdrawHistoryClickShouldIgnoreModal(e.target)) return;
                                  openWithdrawRowDetail(row);
                                }}
                                onKeyDown={(e) => {
                                  if (e.key !== "Enter" && e.key !== " ") return;
                                  e.preventDefault();
                                  openWithdrawRowDetail(row);
                                }}
                              >
                                <div className="deposit_hist_mobile_top">
                                  <span className="deposit_hist_mobile_date">{row.date}</span>
                                  <DepositHistoryStatus
                                    row={{
                                      id: row.id,
                                      action: row.needsSenderConfirm ? "Provide Info" : row.statusLabel,
                                      needsSenderConfirm: row.needsSenderConfirm,
                                    }}
                                    badgeClassName={`deposit_history_action_badge is-${row.needsSenderConfirm ? "pending" : tone}`}
                                    showConfirmButton={false}
                                    confirmTo={withdrawalDeclarationPath(row.id)}
                                  />
                                </div>
                                <div className="withdraw_card_row">
                                  <span className="label">Network</span>
                                  <span className="value">{networkLabelMob}</span>
                                </div>
                                <div className="withdraw_card_row">
                                  <span className="label">Amount</span>
                                  <span className="value">
                                    {row.amount} {row.coin}
                                  </span>
                                </div>
                                <div className="withdraw_card_row">
                                  <span className="label">Source wallet</span>
                                  <span className="value">{row.source}</span>
                                </div>
                                <div className="withdraw_card_row deposit_hist_mobile_row--actions">
                                  <span className="label">Address</span>
                                  <span className="value deposit_hist_mobile_value_actions">
                                    <span className="deposit_history_trunc">{row.addressShort}</span>
                                    {hasAddr ? (
                                      <>
                                        <button
                                          type="button"
                                          className="deposit_history_copy_btn"
                                          aria-label="Copy address"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            copyWithdrawText(row.addressFull, "Address copied");
                                          }}
                                        >
                                          <span aria-hidden className="deposit_history_copy_ico">
                                            <WithdrawHistCopyIcon />
                                          </span>
                                        </button>
                                        {addressExplorerHref ? (
                                          <a
                                            className="deposit_history_copy_btn deposit_history_explorer_link"
                                            href={addressExplorerHref}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            aria-label="View address on explorer"
                                            title="View address on explorer"
                                            onClick={(e) => e.stopPropagation()}
                                          >
                                            <span aria-hidden className="deposit_history_copy_ico">
                                              <WithdrawHistExternalIcon />
                                            </span>
                                          </a>
                                        ) : null}
                                      </>
                                    ) : null}
                                  </span>
                                </div>
                                <div className="withdraw_card_row deposit_hist_mobile_row--actions">
                                  <span className="label">TxID</span>
                                  <span className="value deposit_hist_mobile_value_actions">
                                    <span className="deposit_history_trunc">{row.txShort}</span>
                                    {hasTx ? (
                                      <>
                                        <button
                                          type="button"
                                          className="deposit_history_copy_btn"
                                          aria-label="Copy TxID"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            copyWithdrawText(row.txFull, "TxID copied");
                                          }}
                                        >
                                          <span aria-hidden className="deposit_history_copy_ico">
                                            <WithdrawHistCopyIcon />
                                          </span>
                                        </button>
                                        {txExplorerHref ? (
                                          <a
                                            className="deposit_history_copy_btn deposit_history_explorer_link"
                                            href={txExplorerHref}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            aria-label="View transaction on explorer"
                                            title="View transaction on explorer"
                                            onClick={(e) => e.stopPropagation()}
                                          >
                                            <span aria-hidden className="deposit_history_copy_ico">
                                              <WithdrawHistExternalIcon />
                                            </span>
                                          </a>
                                        ) : null}
                                      </>
                                    ) : null}
                                  </span>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </>
                  ) : null}
                </div>
              ) : (
                <div className="deposit_history_empty withdraw_recent_empty_agce" role="status">
                  <div className="favouriteData">
                    <img
                      src="/images/no_data_vector.svg"
                      className="img-fluid dark_img"
                      width="96"
                      height="96"
                      alt=""
                    />
                    <img
                      src="/images/no_data_vector_light.png"
                      className="img-fluid light_img"
                      width="96"
                      height="96"
                      alt=""
                    />
                  </div>
                </div>
              )}
            </div>

            {isSetPayPinOpen ? (
              <div className="withdraw_confirm_overlay" role="presentation">
                <div className="withdraw_paypin_modal" role="dialog" aria-modal="true" aria-label="Set Pay PIN">
                  <button
                    type="button"
                    className="withdraw_confirm_close"
                    aria-label="Close"
                    onClick={() => {
                      setIsSetPayPinOpen(false);
                      resetPayPin();
                    }}
                  >
                    ×
                  </button>

                  <div className="withdraw_paypin_head">
                    <div className="withdraw_paypin_title">
                      Set Pay PIN{" "}
                      <button
                        type="button"
                        className="withdraw_paypin_eye"
                        aria-label={payPinShow ? "Hide Pay PIN" : "Show Pay PIN"}
                        onClick={() => setPayPinShow((v) => !v)}
                      >
                        <i className={payPinShow ? "ri-eye-line" : "ri-eye-off-line"} aria-hidden="true" />
                      </button>
                    </div>
                  </div>

                  <div className="withdraw_paypin_body">
                    <div className="withdraw_paypin_label">Create Pay PIN</div>
                    <div className="withdraw_paypin_boxes" role="group" aria-label="Pay PIN">
                      {payPinDigits.map((d, idx) => (
                        <input
                          key={idx}
                          ref={(el) => {
                            payPinRefs.current[idx] = el;
                          }}
                          className="withdraw_paypin_box"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          autoComplete="one-time-code"
                          type={payPinShow ? "text" : "password"}
                          value={d}
                          maxLength={1}
                          onChange={(e) => handlePayPinDigit(idx, e.target.value)}
                          onKeyDown={(e) => handlePayPinKeyDown(idx, e)}
                          aria-label={`Digit ${idx + 1}`}
                        />
                      ))}
                    </div>

                    <div className="withdraw_paypin_hint">
                      PIN cannot be in simple/reverse order (e.g 123456, 987654) and the same number cannot appear more than 2 times.
                    </div>

                    <button
                      type="button"
                      className="withdraw_paypin_confirm"
                      disabled={!isPayPinComplete}
                      onClick={() => {
                        setIsSetPayPinOpen(false);
                        resetPayPin();
                      }}
                    >
                      Confirm
                    </button>
                  </div>
                </div>
              </div>
            ) : null}

            {isWithdrawHistoryDetailOpen && selectedWithdrawHistoryRow ? (
              <div
                className="withdraw_confirm_overlay withdraw_hist_detail_overlay"
                role="presentation"
                onClick={() => setIsWithdrawHistoryDetailOpen(false)}
              >
                <div
                  className="withdraw_hist_detail_modal"
                  role="dialog"
                  aria-modal="true"
                  aria-labelledby="withdraw_hist_detail_title"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    type="button"
                    className="withdraw_confirm_close"
                    aria-label="Close"
                    onClick={() => setIsWithdrawHistoryDetailOpen(false)}
                  >
                    ×
                  </button>

                  <div className="withdraw_hist_detail_head">
                    <h2 id="withdraw_hist_detail_title" className="withdraw_hist_detail_title">
                      Withdrawal Details
                    </h2>
                  </div>

                  <div className="withdraw_hist_detail_body">
                    <div
                      className="withdraw_hist_stepper"
                      aria-label="Withdrawal progress"
                      data-outcome={selectedWithdrawHistoryRow.historyOutcomeTone || "pending"}
                    >
                      {selectedWithdrawHistoryRow.steps.map((s, i, arr) => (
                        <div key={`${selectedWithdrawHistoryRow.id}-step-${i}`} className="withdraw_hist_step">

                          <div className="withdraw_hist_step_track" aria-hidden="true">
                            <span className="withdraw_hist_step_dot" />
                            {i < arr.length - 1 ? <span className="withdraw_hist_step_line" /> : null}
                          </div>
                          <div className="withdraw_hist_step_text">
                            <div className={`withdraw_hist_step_title${s.emphasized ? " is-emphasized" : ""}`}>{s.title}</div>
                            {s.subtitle ? (
                              <div className="withdraw_hist_step_sub">{s.subtitle}</div>
                            ) : null}
                            <div className="withdraw_hist_step_time">{s.time}</div>
                          </div>
                        </div>
                      ))}
                    </div>

                    {withdrawStatusTone(selectedWithdrawHistoryRow.statusLabel) === "danger" ? (
                      <p className="withdraw_hist_step_note withdraw_hist_step_note--danger">
                        This withdrawal did not succeed. You can try again from your wallet; if anything looks wrong, contact support with below address.
                      </p>
                    ) : withdrawStatusTone(selectedWithdrawHistoryRow.statusLabel) === "success" ? (
                      <p className="withdraw_hist_step_note">Your withdrawal has completed. You should see funds at the destination address.</p>
                    ) : selectedWithdrawHistoryRow.needsSenderConfirm ? (
                      <>
                        <p className="withdraw_hist_step_note">
                          You have a withdrawal waiting for confirmation. Funds are locked until you submit.
                        </p>
                        <button
                          type="button"
                          className="dd-confirmBtn"
                          onClick={() => navigate(withdrawalDeclarationPath(selectedWithdrawHistoryRow.id))}
                        >
                          Confirm sender
                        </button>
                      </>
                    ) : selectedWithdrawHistoryRow.awaitingAdmin ? (
                      <p className="withdraw_hist_step_note">
                        Waiting for admin approval. Funds are locked. You can cancel this request until it is approved.
                      </p>
                    ) : (
                      <p className="withdraw_hist_step_note">Please note that you will receive an email once it is completed.</p>
                    )}
                    <div className="withdraw_hist_help_links">
                      {/* <Link to="/user_profile/create_tickets" className="withdraw_hist_gold_link">
                        Why hasn&apos;t my withdrawal arrived?
                      </Link> */}
                      <Link to="/user_profile/create_tickets" className="withdraw_hist_gold_link">
                        Report Scam
                      </Link>
                    </div>

                    <div className="withdraw_hist_rows">
                      {/*
                        Derivations for this popup (dynamic):
                        - status tone for color
                        - disable copy/link buttons when missing values
                      */}
                      {(() => {
                        const tone = withdrawStatusTone(selectedWithdrawHistoryRow.statusLabel);
                        const hasAddr = Boolean(selectedWithdrawHistoryRow.addressFull);
                        const hasTx = Boolean(selectedWithdrawHistoryRow.txFull);
                        const txEligible =
                          typeof selectedWithdrawHistoryRow.txExplorerEligible === "boolean"
                            ? selectedWithdrawHistoryRow.txExplorerEligible
                            : withdrawHistoryTxExplorerEligible(selectedWithdrawHistoryRow.txFull);
                        const networkPretty =
                          selectedWithdrawHistoryRow.networkLabel || selectedWithdrawHistoryRow.network;
                        return (
                          <>
                            <div className="withdraw_hist_row">
                              <span className="withdraw_hist_row_label">Status</span>
                              <span className={`withdraw_hist_row_value withdraw_hist_row_value--${tone}`}>
                                {selectedWithdrawHistoryRow.statusLabel}
                              </span>
                            </div>
                            <div className="withdraw_hist_row">
                              <span className="withdraw_hist_row_label">Date</span>
                              <span className="withdraw_hist_row_value">{selectedWithdrawHistoryRow.date}</span>
                            </div>
                            <div className="withdraw_hist_row">
                              <span className="withdraw_hist_row_label">Source</span>
                              <span className="withdraw_hist_row_value">{selectedWithdrawHistoryRow.source}</span>
                            </div>
                            <div className="withdraw_hist_row">
                              <span className="withdraw_hist_row_label">Coin</span>
                              <span className="withdraw_hist_row_value withdraw_hist_row_value--coin">
                                <img
                                  src={selectedWithdrawHistoryRow.coinIconSrc}
                                  alt=""
                                  width={22}
                                  height={22}
                                  onError={makeCoinImageOnError({ short_name: selectedWithdrawHistoryRow.coin })}
                                />
                                {selectedWithdrawHistoryRow.coin}
                              </span>
                            </div>
                            <div className="withdraw_hist_row">
                              <span className="withdraw_hist_row_label">Withdraw amount</span>
                              <span className="withdraw_hist_row_value">{selectedWithdrawHistoryRow.amount}</span>
                            </div>
                            <div className="withdraw_hist_row">
                              <span className="withdraw_hist_row_label">Network fee</span>
                              <span className="withdraw_hist_row_value">{selectedWithdrawHistoryRow.networkFee}</span>
                            </div>
                            <div className="withdraw_hist_row">
                              <span className="withdraw_hist_row_label">Address</span>
                              <span className="withdraw_hist_row_value withdraw_hist_row_value--addr">
                                <span className="withdraw_hist_mono">{selectedWithdrawHistoryRow.addressDisplay}</span>
                                {selectedWithdrawHistoryRow.addressUnverified ? (
                                  <span className="withdraw_hist_badge_unverified">
                                    <span className="withdraw_hist_badge_icon" aria-hidden="true">
                                      !
                                    </span>
                                    Unverified
                                  </span>
                                ) : null}
                                <button
                                  type="button"
                                  className="withdraw_hist_icon_btn"
                                  aria-label="Copy address"
                                  disabled={!hasAddr}
                                  onClick={() => (hasAddr ? copyWithdrawText(selectedWithdrawHistoryRow.addressFull, "Address copied") : null)}
                                >
                                  <WithdrawHistCopyIcon />
                                </button>
                                <a
                                  className={`withdraw_hist_icon_btn withdraw_hist_icon_link${!hasAddr ? " is-disabled" : ""}`}
                                  href={
                                    hasAddr
                                      ? resolveAddressExplorerUrl(selectedWithdrawHistoryRow.network, selectedWithdrawHistoryRow.addressFull)
                                      : undefined
                                  }
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  aria-label="View address on explorer"
                                  aria-disabled={!hasAddr}
                                  onClick={(e) => {
                                    if (!hasAddr) e.preventDefault();
                                  }}
                                >
                                  <WithdrawHistExternalIcon />
                                </a>
                              </span>
                            </div>
                            <div className="withdraw_hist_row">
                              <span className="withdraw_hist_row_label">Network</span>
                              <span className="withdraw_hist_row_value">{networkPretty}</span>
                            </div>
                            <div className="withdraw_hist_row">
                              <span className="withdraw_hist_row_label">TxID</span>
                              <span className="withdraw_hist_row_value withdraw_hist_row_value--addr">
                                <span className="withdraw_hist_mono">{selectedWithdrawHistoryRow.txDisplay}</span>
                                {!txEligible && hasTx ? (
                                  <span className="withdraw_hist_tx_ref_hint" title="Internal reference — not an on-chain hash">
                                    Reference
                                  </span>
                                ) : null}
                                <button
                                  type="button"
                                  className="withdraw_hist_icon_btn"
                                  aria-label="Copy transaction ID"
                                  disabled={!hasTx}
                                  onClick={() => (hasTx ? copyWithdrawText(selectedWithdrawHistoryRow.txFull, "TxID copied") : null)}
                                >
                                  <WithdrawHistCopyIcon />
                                </button>
                                <a
                                  className={`withdraw_hist_icon_btn withdraw_hist_icon_link${!hasTx || !txEligible ? " is-disabled" : ""}`}
                                  href={
                                    hasTx && txEligible
                                      ? resolveTxExplorerUrl(selectedWithdrawHistoryRow.network, selectedWithdrawHistoryRow.txFull)
                                      : undefined
                                  }
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  aria-label="View transaction on explorer"
                                  aria-disabled={!hasTx || !txEligible}
                                  onClick={(e) => {
                                    if (!hasTx || !txEligible) e.preventDefault();
                                  }}
                                >
                                  <WithdrawHistExternalIcon />
                                </a>
                              </span>
                            </div>
                          </>
                        );
                      })()}
                    </div>

                    <p className="withdraw_hist_chat_row">
                      <Link to="/user_profile/create_tickets" className="withdraw_hist_gold_link">
                        Need help? Chat with us
                      </Link>
                    </p>

                    {selectedWithdrawHistoryRow.canCancel ? (
                      <button
                        type="button"
                        className="withdraw_hist_again_btn withdraw_hist_cancel_btn"
                        disabled={withdrawCancelBusy}
                        onClick={() => void cancelPendingWithdrawal(selectedWithdrawHistoryRow)}
                      >
                        {withdrawCancelBusy ? "Cancelling…" : "Cancel withdrawal"}
                      </button>
                    ) : null}

                    <button type="button" className="withdraw_hist_again_btn" onClick={onWithdrawAgainFromHistory}>
                      Withdrawal Again
                    </button>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
    </>
  );
}
